import React from "react";
import "./ui.css";

export default function Table({ headers = [], rows = [], caption, onRowClick }) {
  const hasHeaders = Array.isArray(headers) && headers.length > 0;
  const isClickable = typeof onRowClick === "function";

  return (
    <div className="ui-table-wrap">
      <table className={`ui-table${isClickable ? " ui-table--clickable" : ""}`}>
        {caption ? <caption className="ui-table__caption">{caption}</caption> : null}
        {hasHeaders ? (
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={`${header}-${index}`} scope="col">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
        ) : null}
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              onClick={isClickable ? () => onRowClick(rowIndex) : undefined}
              onKeyDown={isClickable ? (event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  onRowClick(rowIndex);
                }
              } : undefined}
              role={isClickable ? "button" : undefined}
              tabIndex={isClickable ? 0 : undefined}
            >
              {row.map((cell, cellIndex) => (
                <td
                  key={`${rowIndex}-${cellIndex}`}
                  data-label={hasHeaders ? headers[cellIndex] : undefined}
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
